import React, {useEffect, useState} from 'react';
import {useParams, Link as RouterLink} from 'react-router-dom';
import {
    Box,
    Typography,
    Paper,
    CircularProgress,
    Grid,
    Button,
    Alert,
    Stack,
    Divider,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import apiService from '../../services/apiService';

const RewardDetailPage = () => {
    const {id} = useParams();
    const [reward, setReward] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        apiService.get(`/api/rewards/${id}`)
            .then(setReward)
            .catch(err => setError(err.message || 'Failed to load reward details.'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error" sx={{m: 2}}>{error}</Alert>;
    }

    if (!reward) {
        return <Alert severity="info" sx={{m: 2}}>No such reward found.</Alert>;
    }

    const {name, identifier, iconUrl, estimatedValue, sortOrder, createdAt, updatedAt} = reward;

    return (
        <Box sx={{p: 2}}>
            <Typography variant="h4" gutterBottom>{name}</Typography>

            <Grid container spacing={3}>
                {/* Left Column: Icon */}
                <Grid size={{xs: 12, md: 4}}>
                    <Paper elevation={3} sx={{p: 2, textAlign: 'center'}}>
                        <Typography variant="h6" gutterBottom>Icon</Typography>
                        <Divider sx={{mb: 2}}/>
                        <Box
                            component="img"
                            src={iconUrl}
                            alt={name}
                            sx={{
                                width: '100%',
                                maxWidth: '250px',
                                height: 'auto',
                                borderRadius: 2,
                            }}
                        />
                    </Paper>
                </Grid>

                {/* Right Column: Details */}
                <Grid size={{xs: 12, md: 4}}>
                    <Paper elevation={3} sx={{p: 3, height: '100%'}}>
                        <Typography variant="h6" gutterBottom>Details</Typography>
                        <Divider sx={{mb: 2}}/>
                        <Stack spacing={1.5}>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography component="strong">Identifier:</Typography>
                                <Typography>{identifier}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography component="strong">Estimated Value:</Typography>
                                <Typography>{estimatedValue}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography component="strong">Sort Order:</Typography>
                                <Typography>{sortOrder}</Typography>
                            </Stack>
                            <Divider sx={{my: 1}}/>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography component="strong">Created At:</Typography>
                                <Typography>{new Date(createdAt).toLocaleString()}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography component="strong">Updated At:</Typography>
                                <Typography>{new Date(updatedAt).toLocaleString()}</Typography>
                            </Stack>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>

            <Box sx={{mt: 3}}>
                <Button
                    component={RouterLink}
                    to="/rewards"
                    variant="outlined"
                    startIcon={<ArrowBackIcon/>}
                >
                    Back to Rewards
                </Button>
            </Box>
        </Box>
    );
};

export default RewardDetailPage;